import { Component, OnInit } from '@angular/core';

import { UtilService } from "../../../../shared/services/util.service";
import { OrgaoTipoApiService } from "../shared/orgao-tipo-api.service";
import { OrgaoTipoNavigationService } from "../shared/orgao-tipo-navigation.service";
import { OrgaoService } from "../../shared/orgao.service";
import { TipoOrgao } from "../shared/orgao-tipo.model";
import { orgaoTiposModuleName } from "../shared/data.service";

@Component({
  template: require('./orgao-tipo-list.component.html'),
  styles: [require('./orgao-tipo-list.component.css')]
})
export class OrgaoTipoListComponent implements OnInit {
  list: any[] = [];
  loading: boolean = true;
  showDisabled: boolean = false;
  orgaoTiposModuleName: any = orgaoTiposModuleName;

  constructor(
    private _orgaoTipoApiService: OrgaoTipoApiService,
    private _orgaoTipoNavigationService: OrgaoTipoNavigationService,
    private _orgaoService: OrgaoService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._orgaoService.clearSessionStorage();
    this._orgaoTipoNavigationService.goToNew();
  }

  clickEdit(item: TipoOrgao) {
    this._orgaoService.clearSessionStorage();
    this._orgaoTipoNavigationService.goToEdit(item.id);
  }

  clickDelete(item: TipoOrgao) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._orgaoTipoApiService.onGetAll(onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._orgaoTipoApiService.onDelete(item.id, onDone);
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/orgaos/orgao-tipos/orgao-tipo-list/orgao-tipo-list.component.ts
 **/